import React, { useState, useRef, useEffect } from 'react';
import { ApiCore } from '../../api/index';
import { Switch, Toast, Tabs, Mask, Input } from 'antd-mobile-v5';
import { withRouter } from 'react-router-dom';
import cso_cure from '../../static/images_cso/cso_cure.png';
import styles from './index.module.scss';

const api = new ApiCore();


const CSOCure = (props: any) => {
    const [activeKey, setActiveKey] = useState('') //当前激活 tab 面板
    const [labels, setLabels] = useState<any>([]) //所有标签数据
    const [toolData, setToolData] = useState([]) //首页工具数据

    useEffect(() => {
        getData();
        return () => {
        }
    }, [])

    useEffect(() => {
    }, [])

    /**
     * 切换tab
     * @param {*} key 
     */
    const changeTabs = (key: string) => {
        let currentLabels = key ? [key] : []
        setActiveKey(key)
        // getData('search', currentLabels)
        // sessionStorage.setItem('selectToolLabel', key)
    }

        /**
     * 
     * @param type 是否是页面加载第一次请求 
     * @param labels 搜索的标签
     */

    const getData = (type?: string, labels?: Array<string>, name?: string) => {
        let tenantCode = localStorage.getItem('tenantCode');
        let params: any = {
            tenantCode: tenantCode,
            // categoryCode: categoryCode,
            // labels: labels ? labels : selectLabel,
            // name: name ?? searchName
        }

        // Toast.show({
        //     icon: 'loading',
        //     content: '加载中…',
        //     duration: 0
        // })

        api.getScalePage(params).then((res: any) => {
            if (res.code === 0) {

                //如果有搜索条件就把首页工具给屏蔽掉
                // if (params.categoryCode !== '' || params.labels.length > 0 || params.name !== '') {
                //     let Index = res.data.data.findIndex((v: any) => v.code === 'home')
                //     if (Index > -1) {
                //         res.data.data.splice(Index, 1)
                //         res.data.navigation.splice(Index, 1)
                //     }
                // }
                // setNavigation(res.data.navigation)
                setActiveKey(res.data.data[0].code);
                setToolData(res.data.data);
                // Toast.clear()
            } else {
                // Toast.clear()
                Toast.show({
                    content: res.message
                })
            }
        })
    }

    // 跳转工具页
    const toTool = (val: any) => {
        if (val.scaleCode.includes('DRUG') || val.scaleCode.includes('TNM')) {
            props.history.push(`/scale/aggregationScale/${val.scaleCode}?backUrl=${props.history.location.pathname}/`);
        } else {
            props.history.push(`/scale/evaluation/${val.scaleCode}?backUrl=${props.history.location.pathname}/`);
        }
    }
    
    return (
        <div className={styles.CSO_cure_content}>

            <div className={styles.CSO_cure_head}>
                <div className={styles.headerContent}>
                    {toolData.length > 0 && <Tabs
                                    className={styles.tabsContent}
                                    activeLineMode='fixed'
                                    onChange={changeTabs}
                                    activeKey={activeKey}
                                    style={{
                                        '--title-font-size': '16px',
                                        '--active-line-height': '4px',
                                        '--fixed-active-line-width': '28px',
                                        '--active-line-color': '#fff',
                                        '--active-title-color': '#fff',
                                    }}>
                                    {
                                        toolData.map((item: any) => (
                                            <Tabs.Tab title={item.name} key={item.code} >
                                            </Tabs.Tab>
                                        ))
                                    }
                                </Tabs>}
                </div>
            </div>

            <div className={styles.toolsContent}>
                    {
                        toolData.filter((val: any) => val.code === activeKey).map((item: any, index: number) => (
                            <div className={styles.toolsModule} id={'anchor' + item.code} key={index}>
                                {/* <div className={styles.moduleTitle}> */}
                                    {/* <span className={styles.name}>{item.name}</span> */}
                                    {/* {item.code == 'home' && <span className={styles.setting} onClick={openSettingToolModal}>设置</span>} */}
                                {/* </div> */}
                                <div className={styles.toolList}>
                                    {
                                        item.scaleList && item.scaleList.map((v: any, i: number) => (
                                            <div className={`${styles.tool} ${v.categoryCode == 'cate002' ? styles.tool_1_2 : styles.tool_1_3}`} key={i} onClick={() => toTool(v)}>
                                                <img src={v.icon} alt="" />
                                                <div className={styles.toolName}>{v.title}</div>
                                            </div>
                                        ))
                                    }
                                </div>
                            </div>
                        ))
                    }
            </div>
        </div>
    )
}

export default withRouter(CSOCure);